import {Directive} from '@angular/core';

@Directive({
    selector: '[cbTableHead]',
    standalone: false
})
export class CbTableHeadDirective {
}
